import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Network, Handshake, MessageCircle, Package, Users, ArrowLeft } from "lucide-react";

// Espace « Réseau local » partagé par tous les types de membres
// (commerces, clubs, associations, organismes).
const TABS = [
  { to: "/reseau", end: true, icon: Network, label: "Annuaire", testid: "net-tab-directory" },
  { to: "/reseau/connexions", icon: Handshake, label: "Connexions", testid: "net-tab-connections" },
  { to: "/reseau/messages", icon: MessageCircle, label: "Messages", testid: "net-tab-messages" },
  { to: "/reseau/annonces", icon: Package, label: "Annonces d'entraide", testid: "net-tab-listings" },
  { to: "/reseau/profil", icon: Users, label: "Mon profil réseau", testid: "net-tab-profile" },
];

const BACK_BY_ROLE = {
  professional: { to: "/pro", label: "mon espace pro" },
  club: { to: "/espace-club", label: "mon espace club" },
  association: { to: "/espace-association", label: "mon espace association" },
  organization: { to: "/organisme", label: "mon espace organisme" },
};

export default function NetworkLayout() {
  const { user } = useAuth();
  const back = BACK_BY_ROLE[user?.role] || { to: "/", label: "le site" };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="network-layout">
      <header className="bg-[#0F0F11] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 pb-0">
          <Link to={back.to} className="text-sm text-white/60 hover:text-white inline-flex items-center gap-1 mb-3" data-testid="net-back-space">
            <ArrowLeft size={14} /> Retour à {back.label}
          </Link>
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-xl bg-[#E05638] grid place-items-center shrink-0"><Network size={18} /></span>
            <div>
              <h1 className="font-heading text-xl sm:text-2xl font-extrabold leading-tight">Réseau local du 28</h1>
              <p className="text-xs text-white/60">Commerces, clubs, associations et organismes qui s'entraident en Eure-et-Loir.</p>
            </div>
          </div>
          <nav className="flex gap-1 overflow-x-auto mt-4 -mb-px">
            {TABS.map((t) => (
              <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
                className={({ isActive }) => `inline-flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${isActive ? "border-[#E05638] text-white" : "border-transparent text-white/55 hover:text-white"}`}>
                <t.icon size={15} /> {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
        <Outlet />
      </main>
    </div>
  );
}
